export const TAB_TYPES = {
  CONFIGURE_GRADE_LEVELS: "CONFIGURE_GRADE_LEVELS",
  EDIT_GRADES: "EDIT_GRADES",
  PREVIEW_TRANSCRIPTS: "PREVIEW_TRANSCRIPTS",
};

export const STUDENT_DETAIL_ROUTES = {
  CONFIGURE_GRADE_LEVELS: "grade-levels",
  EDIT_GRADES: "edit-grades",
  PREVIEW_TRANSCRIPTS: "preview",
};

export const TAB_TO_ROUTE_MAP = {
  [TAB_TYPES.CONFIGURE_GRADE_LEVELS]:
    STUDENT_DETAIL_ROUTES.CONFIGURE_GRADE_LEVELS,
  [TAB_TYPES.EDIT_GRADES]: STUDENT_DETAIL_ROUTES.EDIT_GRADES,
  [TAB_TYPES.PREVIEW_TRANSCRIPTS]: STUDENT_DETAIL_ROUTES.PREVIEW_TRANSCRIPTS,
};

export const STUDENT_DETAIL_TABS = t => [
  {
    value: TAB_TYPES.CONFIGURE_GRADE_LEVELS,
    label: t("common:configure_label", {
      label: t("common:grade_levels"),
    }),
  },
  {
    value: TAB_TYPES.EDIT_GRADES,
    label: t("common:edit_with_label", {
      label: t("common:grade_plural"),
    }),
  },
  {
    value: TAB_TYPES.PREVIEW_TRANSCRIPTS,
    label: t("common:preview_with_label", {
      label: t("transcript:transcript"),
    }),
    isDefault: true,
  },
];
